import flatten from 'lodash/flatten';
import isEmpty from 'lodash/isEmpty';
import union from 'lodash/union';
import map from 'lodash/map';

import { SET_ORGANIZERS, VIEW_ORGANIZER } from './actionTypes';

import {
    GA_HOME_FEED_CATEGORY,
    GA_SHOW_ORGANIZERS_ACTION,
    GA_VIEW_ORGANIZER_PROFILE_ACTION,
} from '../../constants/analytics';

import { setFollowedByYouInFTF } from '../../utils/organizers';

import { setOrganizerArticlesLoading } from '../app/actions';
import { getUserFollowing } from '../events/api';
import { getFiveToFollowData } from '../../__fixtures__/fiveToFollowContent';
import { transformFiveToFollowResponse } from '../utils';
import { SET_ORGANIZER_ARTICLES } from '../organizerArticle/actionTypes';
import { TABS_CONFIG } from '../../constants/tabConfig';

export const setOrganizers = (data) => ({
    type: SET_ORGANIZERS,
    payload: data,
    meta: {
        analytics: {
            action: GA_SHOW_ORGANIZERS_ACTION,
            label: flatten(Object.values(data)).length,
            category: GA_HOME_FEED_CATEGORY,
        },
    },
});

export const viewOrganizerProfile = (organizerId, label) => (dispatch) =>
    dispatch({
        type: VIEW_ORGANIZER,
        meta: {
            analytics: {
                action: GA_VIEW_ORGANIZER_PROFILE_ACTION,
                label: label || organizerId,
                category: GA_HOME_FEED_CATEGORY,
            },
        },
    });

export const ADD_ORGANIZER_USER_FOLLOW = 'ADD_ORGANIZER_USER_FOLLOW';

export const addOrganizersUsersFollow = (payload) => ({
    type: ADD_ORGANIZER_USER_FOLLOW,
    payload,
});

const setOrganizerArticles = (data) => ({
    type: SET_ORGANIZER_ARTICLES,
    payload: transformFiveToFollowResponse(data),
});

export const getOrganizersUserFollow = () => (dispatch, getState) => {
    const {
        user: { isAuthenticated, publicId },
        content: {
            browseState: { tabKey },
        },
        organizers: { organizersUserFollow },
        location: { placeId },
    } = getState();

    let FTFContent = getFiveToFollowData()[placeId];

    let userFollowedOrganizerIds = organizersUserFollow;

    const { hasFiveToFollow } = TABS_CONFIG[tabKey];

    if (hasFiveToFollow && FTFContent) {
        dispatch(setOrganizerArticlesLoading(true));

        if (isAuthenticated) {
            if (isEmpty(userFollowedOrganizerIds)) {
                return getUserFollowing(publicId)
                    .then((results) => {
                        userFollowedOrganizerIds = union(
                            userFollowedOrganizerIds,
                            map(results.profiles, 'id'),
                        );
                        FTFContent = setFollowedByYouInFTF(
                            FTFContent,
                            userFollowedOrganizerIds,
                        );

                        dispatch(
                            addOrganizersUsersFollow(userFollowedOrganizerIds),
                        );
                        dispatch(setOrganizerArticles(FTFContent));
                        dispatch(setOrganizerArticlesLoading(false));
                    })
                    .catch(() => {
                        // Failed to getUserFollowing. Replace with the newer api actions like feed/src/redux/events/cityBrowseActions.js
                        dispatch(setOrganizerArticlesLoading(false));
                    });
            }
            FTFContent = setFollowedByYouInFTF(
                FTFContent,
                userFollowedOrganizerIds,
            );

            dispatch(addOrganizersUsersFollow(userFollowedOrganizerIds));
            dispatch(setOrganizerArticles(FTFContent));

            return dispatch(setOrganizerArticlesLoading(false));
        }
        dispatch(setOrganizerArticles(FTFContent));

        return dispatch(setOrganizerArticlesLoading(false));
    }

    dispatch(setOrganizerArticlesLoading(false));

    return dispatch(setOrganizerArticles([]));
};

export const SET_ORGANIZERS_USER_FOLLOW = 'SET_ORGANIZERS_USER_FOLLOW';
